import { MRT_ColumnDef, useMaterialReactTable, MaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import React, { useMemo } from 'react'
import { bgLineGridColorDark, bgLineGridColorLight, contaAPagar, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { Funcoes } from '../../Utils/Funcoes'
import moment from 'moment'

type Props = {
    duplicatas: contaAPagar[],
}

interface RowData {
    id: number,
    id_user_exclusao: number,
    dh_exclusao: string,
    motivo_exclusao: string,
    name_user_delete: string,
    nome_fornecedor: string,
    valor: number,
    num_doc: string,
    serie: number,

}

export const GridContaApagarExcluidas = React.memo(({ duplicatas }: Props) => {

    let user = useSelector(state => selectUser(state))

    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569', 
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    const colunas = useMemo<MRT_ColumnDef<contaAPagar>[]>(
        () => [

            {
                accessorKey: 'nome_fornecedor', header: 'Fornecedor', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.nome_fornecedor ? rowData.nome_fornecedor : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'num_doc', header: 'N. Doc', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.num_doc ? rowData.num_doc : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'valor', header: 'Valor (R$)', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.valor ? Funcoes.numberFormat(rowData.valor, 'currency') : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'serie', header: 'Série', size: 20, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.serie ? rowData.serie : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'name_user_delete', header: 'Usuário de Exclusão', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.name_user_delete ? rowData.name_user_delete : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'motivo_exclusao', header: 'Motivo de Exclusão', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.motivo_exclusao ? rowData.motivo_exclusao : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'dh_exclusao', header: 'Data de Exclusão', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.dh_exclusao ? moment(rowData.dh_exclusao).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>)

                }
            },

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: duplicatas,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
    })

    return (
        <>
            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

        </>
    )
})